import React from 'react'
import RenewAgencyBreadCrumb from './RenewAgencyBreadCrumb';
import AgencyDashboard from './AgencyDashboard';

function AgencyDashboardPage() {
    return ( 
        <div className="container-fluid">
            <>
            <RenewAgencyBreadCrumb />
            <AgencyDashboard />
            </>
        </div>
     );
}

export default AgencyDashboardPage;